<template>
  <span class="action-group">
    <span class="action-base" v-if="item === 'F'">◇</span>
    <span class="action-base" v-if="item > 0">◆</span>
    <span class="actions" v-if="item > 0">›</span>
    <span class="actions" v-if="item > 1">›</span>
    <span class="actions" v-if="item > 2">›</span>
    <span class="action-base" v-if="item === 'R'">↻</span>
  </span>
</template>

<script>
export default {
  name: "shared-pf-actions",
  props: ["section", "item", "attackBonus", "damageBonus"],
};
</script>

<style lang="scss" scoped>
.action-group {
  position: relative;
  top: -0.2rem;
}
.action-base {
  vertical-align: middle;
  font-size: 1.1em;
  line-height: 0.5em;
}
.actions {
  margin-left: -0.4em;
  font-size: 1.4em;
  line-height: 0.5rem;
  vertical-align: middle;
  font-weight: normal !important;
}
</style>
